import React, { useState } from 'react';
import * as Constants from "../../../constants/Constants";
import { stripHtmlTags } from "../../../helpers/StripHtmlTags";

interface ProblemStatementInputProps {
  setProblemText: React.Dispatch<React.SetStateAction<string>>;
  setIsProblemTextValid: React.Dispatch<React.SetStateAction<boolean>>;
  charLimit: number;
}

const ProblemStatementInput: React.FC<ProblemStatementInputProps> = ({ setProblemText, setIsProblemTextValid, charLimit }) => {
  const [problemTextCount, setProblemTextCount] = useState(0);
  const [problemText, setLocalProblemText] = useState("");

  const handleProblemTextValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    let strippedValue = stripHtmlTags(inputValue);
    const sanitizedProblem = strippedValue.replace(Constants.PROBLEMTEXT_LOCATION_REGEX_REPLACE, '');

    if (Constants.PROBLEMTEXT_LOCATION_REGEX_PATTERN.test(sanitizedProblem)) {
      event.target.value = sanitizedProblem;
      setLocalProblemText(sanitizedProblem);
      setProblemTextCount(sanitizedProblem.length);
      setProblemText(sanitizedProblem);
      setIsProblemTextValid(sanitizedProblem.length > 0);
    }
  };

  return (
    <auro-input
      data-testid="problem-statement"
      required
      bordered
      validateOnInput
      setCustomValidity="Enter valid problem statement"
      placeholder="Enter problem statement"
      onInput={handleProblemTextValue}
      maxLength={charLimit}
      value={problemText}
    >
      <span slot="label">Problem statement</span>
      <span slot="helptext">{problemTextCount > 0 ? `${problemTextCount} characters (maximum ${charLimit} characters)` : `maximum ${charLimit} characters`}</span>
    </auro-input>
  );
};

export default ProblemStatementInput;